// import {
// 	XMarkIcon,
// } from '@heroicons/react/24/outline'

// import {
// 	Squares2X2Icon,
// } from '@heroicons/react/24/outline'
import { string } from "yup";

const obj = {
  field: [
    {
      title: "Topic or Keyword",
      attr: "content",
      value: "",
      id: "topic",
      placeholder: "Choose a topic to produce content tags.",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string()
        .nullable()
        .trim("Initially whitespace are not allowed")
        .required("Topic or Keyword is Required"),
      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
    },
  ],
  example: [
    {
      title: "Topic or Keyword",
      attr: "content",
      value: "Gaming",
      id: "topic",
      placeholder: "Choose a topic to produce content tags.",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string()
        .nullable()
        .trim("Initially whitespace are not allowed")
        .required("Topic or Keyword is  Required"),
      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
    },
  ],

  editor: {
    output: `1. "Experience the Thrill of Gaming"\n2. "Unlock Your Inner Gamer"\n3. "Ready to Play? Let's Go!"\n4. "Discover a New World of Gaming"\n5. "Game On: The Ultimate Challenge"\n6. "Take Your Gaming to the Next Level"\n7. "Go Beyond the Basics with Gaming"\n8. "Dive into an Exciting World of Gaming"\n9. "A Gamer's Paradise Awaits You!"\n10. "Unlock Endless Possibilities in Gaming`,
 
  },
};

export default obj;
